import { RemoteExportSuspectedStudentsRanking } from 'data/usecases';
import { ExportSuspectedStudentsRankingUseCaseInterface } from 'domain/usecases';
import { makeApiUrlExportSuspectedStudentsRanking } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportSuspectedStudentsRanking =
  (): ExportSuspectedStudentsRankingUseCaseInterface =>
    new RemoteExportSuspectedStudentsRanking(
      makeApiUrlExportSuspectedStudentsRanking(),
      makeAxiosHttpClient(),
    );
